import { render, staticRenderFns } from "./SmallWave.vue?vue&type=template&id=79a8fa50&"
import script from "./SmallWave.vue?vue&type=script&lang=js&"
export * from "./SmallWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports